module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.6.23.0@babel-runtime/core-js/symbol.js
 ** module id = 633
 ** module chunks = 0 1
 **/